import PropTypes from "prop-types";
import React from "react";

import { FormGroupTitle, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { addPushCenterValidator } from "validators/addPushCenterValidator";

import {
  CREATE_APNS_CENTER_MUTATION,
  CREATE_FCM_CENTER_MUTATION,
  READ_APNS_PUSH_CENTERS_NAME,
  READ_FCM_PUSH_CENTERS_NAME,
} from "graphqlQueries/pushCenters";
import { APNS, FCM } from "constants/PushCenters";

const fieldsWithPlaceForError = ["name", "description"];

const initialValues = {
  name: "",
  description: "",
};

const AddPushCenterDialog = (props) => {
  const { centerType } = props;

  let mutation;
  let refetch;
  switch (centerType) {
    case APNS:
      mutation = CREATE_APNS_CENTER_MUTATION;
      refetch = READ_APNS_PUSH_CENTERS_NAME;
      break;
    case FCM:
      mutation = CREATE_FCM_CENTER_MUTATION;
      refetch = READ_FCM_PUSH_CENTERS_NAME;
      break;
    default:
      return;
  }

  return (
    <DialogFormWithMutation
      mutationQueries={mutation}
      refetchQueries={[refetch]}
      initialValues={initialValues}
      validationSchema={addPushCenterValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`New ${centerType} center`}
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title={`${centerType} center information`} />
      <FormTextField name="name" label={`${centerType} center name`} />
      <FormTextField name="description" label="Comment" />
    </DialogFormWithMutation>
  );
};

AddPushCenterDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  centerType: PropTypes.string.isRequired,
};

export default AddPushCenterDialog;
